// Cell text with the full, untruncated text as a tooltip.
export const fullTextRender = (text: string | null | undefined) => <span title={text ?? undefined}>{text}</span>;
